import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl text-neutral-100 mb-4" }, "POS-Login", -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-neutral-200 text-sm mb-2"
}, "Karte", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-neutral-200 text-sm mb-2"
}, "Passwort", -1)
const _hoisted_8 = ["disabled"]

import {computed, inject, onMounted, reactive, ref} from "vue";
import {Axios, AxiosResponse} from "axios";
import {Token, TokenObject} from "@/http";
import {useRouter} from "vue-router";

interface Menu {
  ulid: string;
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();

const pinCode = ref('');
const menu = ref('');
const menus: Menu[] = reactive([]);
const error = ref(null);
const pinCodeElement = ref<HTMLInputElement | null>(null);

const canLogin = computed(() => {
  return pinCode.value.length > 0 && menu.value.length > 0;
});

const http: Axios = inject('http') as Axios;

const login = () => {
  http.post('/menus/' + menu.value + '/authenticate', {pincode: pinCode.value})
    .then((response: AxiosResponse<Token>) => {
      sessionStorage.setItem('token', JSON.stringify(response.data));
    })
    .then(() => {
      router.push({name: 'store', params: {store: menu.value}});
    })
    .catch(e => {
      pinCode.value = '';
      pinCodeElement.value?.focus();
      error.value = e.message;
      console.error(e);
    });
};

onMounted(async () => {
  const tokenObject = new TokenObject();

  if (tokenObject.isValid()) {
    return router.replace({name: 'store', params: {store: tokenObject.for()}});
  }

  http.get('/menus')
    .then(response => {
      menus.push(...response.data.data);
      if (menus.length > 0) {
        menu.value = menus[0].ulid;
      }
    })
    .catch(error => {
      console.error(error);
    });

});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "bg-stone-900 p-8 rounded-lg shadow-lg w-full mx-16 md:max-w-3xl",
      onSubmit: _withModifiers(login, ["prevent"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          id: "email",
          class: "w-full p-2 rounded-lg bg-stone-800 text-neutral-100",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menu).value = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus, (menuOption) => {
            return (_openBlock(), _createElementBlock("option", {
              key: menuOption.ulid,
              value: menuOption.ulid
            }, _toDisplayString(menuOption.title), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, menu.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          class: "w-full p-2 rounded-lg bg-stone-800 text-neutral-100",
          autofocus: "",
          ref: pinCodeElement.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pinCode).value = $event))
        }, null, 512), [
          [_vModelText, pinCode.value]
        ])
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: "w-full bg-neutral-500 text-neutral-100 p-2 rounded-lg disabled:cursor-not-allowed disabled:text-neutral-400",
        disabled: !canLogin.value
      }, "Login ", 8, _hoisted_8)
    ], 32)
  ]))
}
}

})